import axiosCall, { getConfig } from 'src/services/axiosHelper';
import { convertDrgAnalyseData } from 'src/services/converters/GrouperServiceConverter';
import { DrgAnalyseResponseDto } from 'src/contracts/drgAnalyseResponseDto';
import { DrgAnalysis } from 'src/contracts/drgAnalysis';
import { AnalyzeDrgRequestDto } from 'src/contracts/analyzeDrgRequestDto';
import { GetResearchResponse } from 'src/contracts/getMetadataResearchResponse';

export async function analyzeDRG(request: AnalyzeDrgRequestDto): Promise<DrgAnalysis | undefined> {
  const data = await axiosCall<DrgAnalyseResponseDto | false>({
    method: 'post',
    data: request,
    url: `/grouper/drg/analyze/${encodeURIComponent(getConfig().facilityCode)}`,
  }, false);
  if (!data) {
    return undefined;
  }
  return convertDrgAnalyseData(data);
}

export async function researchData(code: string, codeType: string): Promise<GetResearchResponse | undefined> {
  const data = await axiosCall<GetResearchResponse | false>({
    method: 'get',
    url: `/grouper/${getConfig().facilityCode}/research/${encodeURIComponent(codeType)}/${encodeURIComponent(code)}?all=true`,
  }, false);

  if (!data) {
    return undefined;
  }
  return data;
}